module.exports = __webpack_public_path__ + "fed274b424bc19fdac30d83b94c8e9a0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-bluegold.png
// module id = 2530
// module chunks = 0